import React from "react";
import { TextField, Checkbox, RaisedButton } from "material-ui";
import Tooltip from "../Tooltip";
import AbsoluteLabel from "../AbsoluteLabel";

export default ({ state, handleChange }) => {
  return (
    <div>
      {state.keep_ligand ? (
        <div className={"sub-option"}>
          <div className={"black-label"}>
            Indicate ligand ID in the PDB file:
          </div>
          <TextField
            name={"ligand_id"}
            hintText="For example &quot;ANP&quot;"
            value={state.ligand_id}
            onChange={e => handleChange(e)}
            errorText={state.errors.ligand_id}
          />
          <Checkbox
            name={"add_hydrogens"}
            checked={state.add_hydrogens}
            onCheck={(e, v) => handleChange(e, v)}
            label={
              <AbsoluteLabel>
                Add hydrogen atoms to ligand structure
                <Tooltip
                  id={"hydrogen-tooltip"}
                  label={
                    "Hydrogen atoms will be added using the Babel program."
                  }
                />
              </AbsoluteLabel>
            }
            errorText={state.errors.add_hydrogens}
          />
          <div className={"black-label"}>
            Specify total ligand charge:{" "}
            <Tooltip
              id={"total-ligand-tooltip"}
              label={
                "Partial charges will be calculated using AM1-BCC method with Antechamber"
              }
            />
          </div>
          <TextField
            name={"ligand_charge"}
            hintText="500"
            value={state.ligand_charge}
            onChange={e => handleChange(e)}
            errorText={state.errors.ligand_charge}
          />
        </div>
      ) : (
        ""
      )}
      <Checkbox
        name={"separate_ligand"}
        checked={state.separate_ligand}
        onCheck={(e, v) => handleChange(e, v)}
        label={
          <AbsoluteLabel>
            Provide separate ligand file in mol2 format
            <Tooltip
              id={"separate-ligand-tooltip"}
              label={"Upload your own ligand in MOL2 format."}
            />
          </AbsoluteLabel>
        }
        errorText={state.errors.separate_ligand}
      />
      {state.separate_ligand ? (
        <div className={"sub-option"}>
          <br />
          <div className={"black-label"}>Upload file:</div>
          <RaisedButton
            label={
              state.upload_ligand === ""
                ? "Add"
                : `Selected (${state.upload_ligand.replace(/^.*[\\/]/, "")})`
            }
            containerElement="label"
          >
            <input
              onChange={e => handleChange(e)}
              name={"upload_ligand"}
              type="file"
              style={{ display: "none" }}
              accept={[".mol2"]}
            />
          </RaisedButton>
          <br />
          <Checkbox
            name={"ligand_hydrogen_atoms"}
            checked={state.ligand_hydrogen_atoms}
            onCheck={(e, v) => handleChange(e, v)}
            label="Add hydrogen atoms to ligand structure"
            errorText={state.errors.ligand_hydrogen_atoms}
          />

          <Checkbox
            name={"s_ligand_charge_check"}
            checked={state.s_ligand_charge_check}
            onCheck={(e, v) => handleChange(e, v)}
            label="Calculate atomic partial charges"
            errorText={state.errors.s_ligand_charge_check}
          />
          {state.s_ligand_charge_check && (
            <div className={"sub-option"}>
              <div className={"black-label"}>Specify total ligand charge:</div>
              <TextField
                name={"s_ligand_charge"}
                hintText="X"
                value={state.s_ligand_charge}
                onChange={e => handleChange(e)}
                errorText={state.errors.s_ligand_charge}
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SubmitForm/ligand_section.js